import { Skeleton } from './Skeleton';

// Suspense fallback for lazy-loaded routes. Renders a card-shaped
// silhouette (header + 3 stacked card blocks) so the swap from
// fallback → real screen feels like content settling in, rather than
// a flash of "Loading…" text followed by a sudden full screen.
export function RouteFallback() {
  return (
    <div
      className="container"
      role="status"
      aria-label="Loading screen"
      style={{ paddingBlock: 'var(--space-5)' }}
    >
      <div style={{ marginBlockEnd: 'var(--space-5)' }}>
        <Skeleton width="50%" height={32} />
        <div style={{ marginBlockStart: 'var(--space-2)' }}>
          <Skeleton width="30%" height={16} />
        </div>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-4)' }}>
        <Skeleton height={96} radius="var(--radius-md)" />
        <Skeleton height={96} radius="var(--radius-md)" />
        <Skeleton height={96} radius="var(--radius-md)" />
      </div>
    </div>
  );
}
